import React, { useCallback } from 'react';
import { useHistory } from 'react-router';
import Grid from '@material-ui/core/Grid';
import styled, { css } from 'styled-components';

import { Button } from 'fpay-ui';

import Success from '@components/Success';
import { withTranslation } from 'react-i18next';
import * as ROUTES from '@constants/routes';
import { isAllowed } from '@helpers/auth';

const FlowButton = styled(Button)(
  ({ theme }) => css`
    height: 48px;
    padding: 12px 24px;
    margin: 0px 12px;
  `
);

const ButtonsContainer = styled.div`
  display: flex;
  margin-top: 16px;
`;

const h2Style = {
  fontFamily: 'Roboto',
  fontSize: '24px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  marginTop: '0',
  marginBottom: '10px',
  lineHeight: '1.33',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: '#444b62',
};

const ErrorRefund = ({ t }) => {
  const history = useHistory();
  const { fraudError: isFraudRefundError, messageCode } = history?.location?.state ?? {};

  const shouldShowHelpButton = (isFraudRefundError || messageCode) && isAllowed('HELP');
  const shouldShowTransactionsButton = !isFraudRefundError;

  const handleHelpButtonClick = useCallback(() => history.push(ROUTES.HELP), []);
  const handleTransactionsButtonClick = useCallback(() => history.push(ROUTES.TRANSACTIONS), []);

  let subTextCode;

   subTextCode = isFraudRefundError
    ? 'transactions.detail.fraudErrorRefundSubTitle'
    : messageCode;

   subTextCode = messageCode === 'RFD-03' ? 'transactions.detail.errorAlreadyRefundSubTitle' : subTextCode ?? 'transactions.detail.errorRefundSubTitle';

  return (
    <Grid container>
      <Success
        imgStyle={{ margin: 'auto', marginTop: '83px' }}
        h2Style={h2Style}
        firstLine={t('transactions.detail.errorRefundTitle')}
        transactionsFlag
        gridProds={{ justify: 'center', container: true }}
        helperText={t(subTextCode)}
        type="error"
        maxWidth={350}
        shouldShowButton={false}
        shouldWrapChildren={false}
      >
        <ButtonsContainer>
          {shouldShowTransactionsButton && (
            <FlowButton
              type={shouldShowHelpButton ? 'outlined' : 'primary'}
              data-testid="helpButton"
              onClick={handleTransactionsButtonClick}
            >
              {t('transactions.refunds.successButton')}
            </FlowButton>
          )}
          {shouldShowHelpButton && (
            <FlowButton data-testid="helpButton" onClick={handleHelpButtonClick}>
              {t(isFraudRefundError ? 'transactions.refunds.fraudErrorButtonText' : 'common.help')}
            </FlowButton>
          )}
        </ButtonsContainer>
      </Success>
    </Grid>
  );
};

export default withTranslation()(ErrorRefund);
